import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { markNotificationsRead } from "../redux/actions/currentProfileActions";
import { GoPerson, GoInfo } from "react-icons/go";
import { Link } from "react-router-dom";
import {
  IonContent,
  IonHeader,
  IonPage,
  useIonViewWillEnter,
} from "@ionic/react";
import Header from "../components/layout/Header";
import { Helmet } from "react-helmet-async";
function Alerts() {
  const { data } = useSelector((state) => state.currentProfile);
  const alerts = data.notifications;
  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    if (alerts && alerts.some((n) => !n.read)) {
      dispatch(markNotificationsRead());
    }
  }, [alerts, dispatch]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">{/* <Header /> */}</IonHeader>
        <IonContent>
          {alerts
            ? alerts.map((notification, idx) => {
                if (notification.type === "follow") {
                  return (
                    <div
                      key={idx}
                      className="notification display-flex align-items-c"
                    >
                      <GoPerson />
                      <Link
                        to={`/profile/${notification.message.split(" ")[0]}`}
                        style={{ color: "#d80621", marginRight: "6px" }}
                      >
                        {" "}
                        @{notification.message.split(" ")[0]}{" "}
                      </Link>
                      <p>{notification.message}</p>
                    </div>
                  );
                } else {
                  const content = (
                    <div className="notification display-flex align-items-c">
                      <GoInfo />
                      <p>{notification.message}</p>
                    </div>
                  );

                  return notification.link ? (
                    <Link
                      to={notification.link}
                      key={idx}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {content}
                    </Link>
                  ) : (
                    <div key={idx}>{content}</div>
                  );
                }
              })
            : "loading.."}
        </IonContent>
      </IonPage>
    </>
  );
}

export default Alerts;
